import { WithStyles, withStyles } from '@mui/styles';

import { ApiConnections } from './apiConnections';
import { muiStyles } from './apiConnectionsStyles';

export type IApiConnectionsProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(ApiConnections);